import type { Ceviri } from "../tip";
import type { ui as tr } from "../tr/ui";

/** English dictionary · ui. */
export const ui: Ceviri<typeof tr> = {
  anlasilan: (deger) => `Read as: ${deger}`,
  alanZorunlu: "This field is required.",
  yukleniyor: "Loading",
  veriOkunamadi: "Data could not be read",
  paraBirimiTaninmiyor: (kod) => `${kod} — not recognised`,
};
